
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Input } from '@angular/core';
import { LayoutService } from '../../../services/layout.service';
import { Subscription } from 'rxjs';
import { Message, MessageService } from 'primeng/api';
import { I18Service } from '../../../services/i18Service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  providers: [MessageService]

})
export class BreadcrumbComponent implements OnInit {
  @Input()
  public deliminator: string = '>';
  subscription: Subscription = new Subscription();

  breadcrumbs: Array<{ label: string; url: string }>;
  BCTabTitle = '';
  private subscriptions: Subscription[] = [];

  constructor(private layoutService: LayoutService, private messageService: MessageService,
    private i18Service: I18Service, private translate: TranslateService,
    private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {


    let subscription = this.i18Service.getLocalEvent()
      .subscribe(local => this.translate.use(local))
    this.subscriptions.push(subscription);


    this.subscription.add(
      this.layoutService.getTabTitle.subscribe(
        (TabTitle) => (this.BCTabTitle = TabTitle.title)
      )
    );

    this.subscription.add(
      this.layoutService.getnewMsgValue.subscribe(
        (newMsgValue) => (this.showMsg(newMsgValue))
      )
    );



    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(event => {
        this.breadcrumbs = [];
        let currentRoute = this.activatedRoute.root,
          url = '';
        do {
          const childrenRoutes = currentRoute.children;
          currentRoute = null;
          childrenRoutes.forEach(route => {
            if (route.outlet === 'primary') {
              const routeSnapshot = route.snapshot;

              url +=
                '/' + routeSnapshot.url.map(segment => segment.path).join('/');
              this.breadcrumbs.push({
                label: route.snapshot.data.breadCrum,
                url: url
              });

              currentRoute = route;
            }
          });
        } while (currentRoute);
      });
  }
  showMsg(newMsgValue) {
    this.messageService.clear();
    this.messageService.add(newMsgValue)
  }
}
